<template>
  <div class="animated fadeIn catatan-dana">
    <b-card>
      <div slot="header">
        Catatan Pemakaian Dana
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="openDetail" v-if="showList">Show Detail Trx.</b-button>
          <b-button variant="primary mr-1" @click="openList" v-if="showDetail">Show Header List</b-button>
          <!-- <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>-->
          <b-button variant="primary mr-1" @click="exportxls()" v-if="showDetail">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>

      <b-card no-body v-if="showList">
        <template v-slot:header v-if="(filterExpHeaderShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filterExpHeader"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filterExpHeader" @click="clearFilterExpHeader">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox
                v-model="filterExpHeaderShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b>{{ filterExpHeaderShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOnExpHeader" class="mt-1">
                  <b-form-checkbox
                    v-for="(item,index) in expHeader.fields.filter(x=>x.filterable)"
                    :key="index"
                    :value="item.key"
                  >{{item.label}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="expHeader.items"
          :fields="expHeader.fields"
          show-empty
          @row-clicked="rowClicked"
          :filter="filterExpHeader"
          :filterIncludedFields="filterOnExpHeader"
          @filtered="onFilteredExpHeader"
        >
        <template v-slot:cell(action)="data">
          <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item @click="rowEdit(data.item)" href="#" ><span v-if="(data.item.udahKlaim==1)">View</span><span v-else>Edit</span> </b-dropdown-item>
            <b-dropdown-item @click="rowTrx(data.item)" href="#" >Show Detail Trx.</b-dropdown-item>
            <b-dropdown-item @click="rowTrxAdd(data.item)" href="#" :disabled="(data.item.udahKlaim==1)">Add Trx.</b-dropdown-item>          
            <b-dropdown-item @click="rowTrxExport(data.item)" href="#" >Export Detail Trx.</b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.udahKlaim==1)"> Delete</b-dropdown-item>
          </b-dropdown>
        </template>          

          <template v-slot:cell(lineno)="data">{{ data.index +1}}</template>

          <template v-slot:cell(umasuk)="data">{{(data.item.umasuk)|numFormat}}</template>
          <template v-slot:cell(ukeluar)="data">{{(data.item.ukeluar)|numFormat}}</template>
          <template v-slot:cell(saldo)="data">{{(data.item.saldo)|numFormat}}</template>

          <!-- <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click="delConfirm(data.index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template> -->
          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div class="ml-1">
              Showing {{(expHeader.page - 1) * expHeader.limit + 1}}
              to
              <span
                v-if="((expHeader.page * expHeader.limit)>expHeader.total)"
              >{{expHeader.total}}</span>
              <span v-else>{{expHeader.page * expHeader.limit}}</span>
              of {{expHeader.total}} entries.
            </div>
          </b-col>
          <b-col cols="4" align="center">
            <span class="mr-1">limit per page :</span>
            <select v-model="expHeader.limit" style="width:60px;">
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
              <option>60</option>
              <option>70</option>
              <option>80</option>
              <option>90</option>
            </select>
            <b-form-checkbox
              v-model="filterExpHeaderShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="ml-2"
            >
              <b>{{ filterExpHeaderShow }}</b> Filter
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="expHeader.total"
              :per-page="expHeader.limit"
              v-model="expHeader.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>

      <b-card v-if="showDetail">
        <b-row class="mt-1">
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label>Nama Dana</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="expHeader.selected.namadana"
                disabled
                placeholder="Nama harus unik(tdk boleh sama)"
              ></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Nomor Referensi</label>
              </b-input-group-prepend>
              <b-form-input v-model="expHeader.selected.nomor" disabled></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5" class="text-right">
            <b-input-group>
              <b-input-group-prepend>
                <label>Total Dana</label>
              </b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text" style="width:60px;">{{expHeader.selected.matauang}}</span>
            </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                separator=","
                v-model="expHeader.selected.umasuk"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
            <b-button class="btn btn-success" @click="addExpLines">Tambah Transaksi</b-button>
          </b-col>
        </b-row>
        <b-card no-body v-if="(filterExpLineShow=='Hide')" class="mt-1">
          <template v-slot:header>
            <b-row>
              <b-col lg="3">
                <b-input-group size="sm" class="mt-1">
                  <b-input-group-prepend>
                    <span class="pt-1 mr-1">FILTER</span>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filterExpLine"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filterExpLine" @click="clearFilterExpLine">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-form-checkbox
                  v-model="filterExpLineShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                >
                  <b>{{ filterExpLineShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
              <b-col lg="9">
                <b-form-group
                  label="FILTER ON :"
                  label-cols-sm="1"
                  description="Leave all unchecked to filter on all data"
                  class="mb-0"
                >
                  <b-form-checkbox-group v-model="filterOnExpLine" class="mt-1">
                    <b-form-checkbox
                      v-for="(item,index) in expLinesFields.filter(x=>x.filterable)"
                      :key="index"
                      :value="item.key"
                    >{{item.label}}</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </b-card>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          bordered
          style="font-size:smaller;"
          :items="expLines.items"
          :fields="expLinesFields"
          show-empty
          :filter="filterExpLine"
          :filterIncludedFields="filterOnExpLine"
          @filtered="onFilteredExpLine"
        >
          <template v-slot:cell(lineno)="data">{{ data.index +1}}</template>
          <template
            v-slot:cell(trxdate)="data"
          >{{ data.item.trxdate | moment('DD-MMM-YYYY HH:mm:ss')}}</template>
          <template v-slot:cell(kasbon)="data">
            <span v-if="data.item.kasbon==1">Kasbon</span>
            <span v-else>Biaya</span>
          </template>
          <template v-slot:cell(ukeluar)="data">
            <span v-if="data.item.kodeacc">{{data.item.ukeluar | numFormat}}</span>
          </template>
          <template v-slot:cell(saldo)="data">
            <span v-if="data.item.kodeacc">{{data.item.saldo | numFormat}}</span>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="editExpLines(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click="delLineConfirm(data.index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
          </template>
          <template v-slot:custom-foot="data">
            <b-tr>
              <b-td class="tebal" style="text-align:right" colspan="6">
                <strong>Total Pemakaian Dana:  {{expHeader.selected.matauang}}</strong>
              </b-td>
              <b-td class="total" style="text-align:right">
                <strong>{{ttlKredit | numFormat}}</strong>
              </b-td>
              <b-td class="total" :colspan="dimension.length+4"></b-td>
            </b-tr>
          </template>
        </b-table>
        <!-- <b-row class="mt-1">
          <b-col cols="9"></b-col>
          <b-col cols="3" class="text-right">
            <b-button class="btn btn-success" @click="addExpLines">Tambah Transaksi</b-button>
          </b-col>
        </b-row>-->
        <b-row class="mt-2">
          <b-col cols="4">
            <div class="ml-1">
              Showing {{(expLines.page - 1) * expLines.limit + 1}}
              to
              <span
                v-if="((expLines.page * expLines.limit)>expLines.total)"
              >{{expLines.total}}</span>
              <span v-else>{{expLines.page * expLines.limit}}</span>
              of {{expLines.total}} entries.
            </div>
          </b-col>
          <b-col cols="4" align="center">
            <span class="mr-1">limit per page :</span>
            <select v-model="expLines.limit" style="width:60px;">
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
              <option>60</option>
              <option>70</option>
              <option>80</option>
              <option>90</option>
            </select>
            <b-form-checkbox
              v-model="filterExpLineShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="ml-2"
            >
              <b>{{ filterExpLineShow }}</b> Filter
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="expLines.total"
              :per-page="expLines.limit"
              v-model="expLines.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuCoaShow"
      size="lg"
      :hide-footer="true"
      title="List of GL Account"
      :centered="true"
    >
      <lku-coa @click="onSelectLkuCoa" :lookupdata="accountbiaya"></lku-coa>
    </b-modal>
    <b-modal
      v-model="showForm"
      header-bg-variant="primary"
      :title="`${ (frmhdr.trxhdrkey) ? 'Edit':'Add'} - Catatan Pemakaian Dana`"
      :centered="true"
      @ok="save"
    >
      <b-input-group>
        <b-input-group-prepend>
          <label style="width:100px !important;">Nama Dana</label>
        </b-input-group-prepend>
        <b-form-input
          v-model="frmhdr.namadana"
          :state="!$v.frmhdr.namadana.$error"
          placeholder="Nama harus unik(tdk boleh sama)"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label style="width:100px !important;">Nomor Catatan</label>
        </b-input-group-prepend>
        <b-form-input v-model="frmhdr.nomor" placeholder="No. Pinjaman/Uang Muka/Cash Advance" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label style="width:100px !important;">Total Dana</label>
        </b-input-group-prepend>
            <b-input-group-prepend>
              <b-form-select class="input-group-text" v-model="frmhdr.matauang" :plain="true" :options="currency"></b-form-select>
            </b-input-group-prepend>
        <my-number
          class="form-control text-right"
          separator=","
          v-model="frmhdr.umasuk"
          :precision="2"
          :state="!$v.frmhdr.umasuk.$error"
        ></my-number>        
        <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmhdr.udahKlaim" class="mt-1" v-if="(frmhdr.trxhdrkey)">Udah Klaim</b-form-checkbox>
      </b-input-group>
    </b-modal>
    <b-modal
      v-model="showDetailFrm"
      header-bg-variant="primary"
      title="Transaksi Pemakaian Dana"
      size="lg"
      :centered="true"
      @ok="saveExpLines"
    >
      <b-input-group>
        <b-input-group-prepend>
          <label>Uraian Transaksi</label>
        </b-input-group-prepend>
        <b-form-input v-model="expLinesObj.uraian" :state="!$v.expLinesObj.uraian.$error"></b-form-input>
      </b-input-group>
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Dibayarkan Kpd</label>
            </b-input-group-prepend>
            <b-form-input v-model="expLinesObj.dibayarke" :state="!$v.expLinesObj.dibayarke.$error"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nomor/Tanda Bukti</label>
            </b-input-group-prepend>
            <b-form-input v-model="expLinesObj.reff"  :state="!$v.expLinesObj.reff.$error"></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tanggal Transaksi</label>
            </b-input-group-prepend>
            <b-input-group-append>
              <VueCtkDateTimePicker
                v-model="expLinesObj.tanggal"
                :state="!$v.expLinesObj.tanggal.$error"
                style="width: 230px !important;"
              ></VueCtkDateTimePicker>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nilai Transaksi</label>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text" style="width:75px;">{{expHeader.selected.matauang}}</span>
            </b-input-group-prepend>
            <my-number
              class="form-control text-right"
              v-model="expLinesObj.nilai"
              :minus="true"
              :precision="2"
            ></my-number>
            <b-form-checkbox
              class="ml-2 mt-2"
              v-model="expLinesObj.kenappn"
              value="1"
              unchecked-value="0"
              @change="calcTaxes()"
            >kena PPN</b-form-checkbox>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-input-group>
        <b-input-group-prepend>
          <label>Jenis Transaksi</label>
        </b-input-group-prepend>
        <b-form-radio-group class="mt-2" v-model="expLinesObj.kasbon">
          <b-form-radio value="1">Kas Bon (talangan belum jadi Biaya)</b-form-radio>
          <b-form-radio value="0">Biaya (sudah ada Bukti Biaya)</b-form-radio>
        </b-form-radio-group>
      </b-input-group>
      <b-input-group v-if="(expLinesObj.kasbon==0)">
        <b-input-group-prepend>
          <label>GL Account No.</label>
        </b-input-group-prepend>
        <b-form-input
          readonly
          v-model="expLinesObj.glAccount"
          @keyup.13.native="lkuCoaShow=true"
          :state="!$v.expLinesObj.kodeacc.$error"
        ></b-form-input>
        <b-input-group-append>
          <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount">
            <i class="fa fa-search"></i>
          </b-btn>
        </b-input-group-append>
      </b-input-group>

      <!-- <b-form-row v-if="(expLinesObj.kasbon==0)">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>PPN Masukan</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="expLinesObj.kenappn"
              :plain="true"
              :options="YesNo"
              @change="calcTaxes()"
            ></b-form-select>
            <b-input-group-prepend>
              <span class="input-group-text" style="width:70px;">tarif</span>
            </b-input-group-prepend>
            <b-form-input v-model="expLinesObj.ppn" @change="calcTaxes()" type="number" readonly></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">
                <i class="fa fa-percent"></i>
              </span>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-form-row> -->

      <b-form-row v-if="(expLinesObj.kasbon==0)">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>PPH dipotong</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="expLinesObj.pasalpph"
              :plain="true"
              :options="lookupPPH"
              style="width:25% !important;"
            ></b-form-select>
            <b-input-group-prepend>
              <span class="input-group-text">tarif</span>
            </b-input-group-prepend>
            <b-form-input v-model="expLinesObj.pph" type="number" @change="calcTaxes()"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">
                <i class="fa fa-percent"></i>
              </span>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <b-form-select
                style="width:158px;font-size:small;"
                v-model="calcPPh"
                :plain="true"
                :options="calcuationPPH"
              ></b-form-select>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text" style="width:60px;">{{expHeader.selected.matauang}}</span>
            </b-input-group-prepend>
            <my-number
              class="form-control text-right"
              v-model="expLinesObj.nilaipph"
              :precision="2"
              :readonly="(calcPPh===1)"
            ></my-number>
            <b-form-checkbox
              id="chkGrossUp"
              class="ml-2 mt-2"
              v-model="expLinesObj.grossup"
              value="1"
              unchecked-value="0"
            >Gross Up</b-form-checkbox>
          </b-input-group>
        </b-col>
      </b-form-row>
      <h4>Dimmension</h4>
      <v-dim :model="expLinesObj" :horizontal="true"></v-dim>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="del">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal v-model="showDelLineConfirm" title="Delete Record?" :centered="true" @ok="delExpLines">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
  </div>
</template>

<style lang="scss">
    .catatan-dana {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    }
 
</style>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../components/my-number";
import vDim from "./lookup/dim";
import lkuCoa from "./lookup/lkuCoaExpenses";
import expense from "../apis/expensesnote";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmhdr: {
      namadana: { required },
      umasuk: { required }
    },
    expLinesObj: {
      tanggal: { required },
      uraian: { required },
      reff: { required },
      dibayarke: { required },
      nilai: { required },
      ukeluar: { required },
      kasbon: { required },
      kodeacc: {
        required: function() {
          if ((this.expLinesObj.kasbon || 0) == 1) {
            return true;
          } else if ((this.expLinesObj.kodeacc || "") == "") {
            return false;
          } else return true;
        }
      }
    }
  },
  data() {
    return {
      filter: { kodeaw: "", tgl1: "", tgl2: "", tabIndex: 1 },
      isLoading: false,
      saveEnabled: true,
      showList: true,
      showForm: false,
      showDetail: false,
      showDetailFrm: false,
      showDelConfirm: false,
      showDelLineConfirm:false,
      reportUrl: null,
      showReport: false,
      tahun: moment(this.$store.state.user.tglaktif).format("YYYY"),
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" }
      ],
      YesNo: [
        { value: 1, text: "YES" },
        { value: 0, text: "NO" }
      ],
      lookupPPH: [],
      lkuCoaShow: false,
      accountbiaya: [],
      frmhdr: {
        trxhdrkey:"",
        namadana: "",
        tanggal: "",
        umasuk: "", 
        matauang: "IDR",
        udahKlaim:0
      },
      filterExpHeaderShow: "Show",
      expHeader: {
        items: [],
        selected: {},
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "nomor",
            label: "Nomor Catatan",
            thStyle: "width:140px",
            sortable: true
          },
          {
            key: "namadana",
            label: "Nama Dana",
            sortable: true,
            filterable: true
          },
          {
            key: "matauang",
            thStyle: "width:50px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "umasuk",
            label: "Total Dana",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            filterable: true
          },
          {
            key: "ukeluar",
            label: "Pemakaian",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            filterable: true
          },
          {
            key: "saldo",
            label: "Saldo",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            filterable: true
          },
          {
            key: "udahKlaim",
            label: "Udah Klaim",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-center"
          }

        ]
      },
      filterOnExpHeader: [],
      filterExpHeader: null,
      // start expline
      expLinesObj: {
        tanggal: "",
        kodeacc: "",glAccount:'',
        ukeluar: "",
        dibayarke: "",
        uraian: "",
        reff: "",
        matauang: this.$store.state.user.matauang,
        nilai: "",
        pasalpph: "NO WHT",
        pph: 0,
        kasbon: 0
      },
      uanguser: this.$store.state.user.matauang,
      currency:[],
      filterExpLineShow: "Show",
      expLines: {
        items: [],
        selected: {},
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      filterOnExpLine: [],
      filterExpLine: null,
      // end expline
      ttlKredit: 0
    };
  },
  components: { VueCtkDateTimePicker, myNumber, vDim, Loading, lkuCoa },
  computed: {
    expLinesFields() {
      const fields = [
        {
          key: "lineno",
          label: "No.",
          thStyle: "width:40px"
        },
        {
          key: "trxdate",
          label: "Tgl. Transaksi",
          sortable: true,
          filterable: true
        },
        {
          key: "dibayarke",
          label: "Dibayar kpd",
          sortable: true,
          filterable: true
        },
        {
          key: "uraian",
          label: "Uraian Transaksi",
          sortable: true,
          filterable: true
        },
        {
          key: "kasbon",
          label: "Jenis Transaksi",
          sortable: true,
          filterable: true
        },
        {
          key: "reff",
          label: "No. Bukti",
          sortable: true,
          filterable: true
        },
        {
          key: "ukeluar",
          label: "Nilai",
          sortable: true,
          filterable: true,
          tdClass: "text-right"
        },
        {
          key: "saldo",
          label: "Saldo",
          sortable: true,
          filterable: true,
          tdClass: "text-right"
        }
      ];
      const dimension = this.dimension;
      dimension.map(kol => {
        fields.push({
          key: kol.value,
          label: kol.text,
          sortable: true,
          filterable: true
        });
      });

      fields.push({
        key: "action",
        label: "Action",
        sortable: true
      });
      return fields;
    },
    dimension() {
      return this.$store.state.dimension;
    },
    invalidExpLines() {
      this.$v.expLinesObj.$touch();
      return this.$v.expLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.frmhdr.$touch();
      return this.$v.frmhdr.$invalid;
    },
    nilai() {
      return this.expLinesObj.pasalpph;
    },
    pasalpph() {
      return this.expLinesObj.pasalpph;
    }
  },
  watch: {
    nilai: function(newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    pasalpph: function(newval) {
      const item = this.lookupPPH.find(p => p.value == newval);
      if (item) {
        this.expLinesObj.pph = parseFloat(item.pph);
        this.calcTaxes();
      }
    }
  },
  created: async function() {
    this.frmhdr.tanggal = moment();
    const [a, b, c, d] = await Promise.all([
      expense.accountbiaya(),
      expense.currency(),
      expense.pasalpph(),
      expense.list()
    ]);
    this.accountbiaya = a;
    this.currency = b;
    this.lookupPPH = c;
    this.expHeader.items = d || [];
  },
  methods: {
    rowEdit(record) {
      this.rowClicked(record)
      this.edit(record);
    },
    rowTrx(record) {
      this.rowClicked(record)
      this.openDetail();
    },
    rowTrxAdd(record) {
       this.rowClicked(record);
        this.addExpLines();        
    },
    rowTrxExport(record) {
      this.rowClicked(record);
        this.exportxls();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.showDelConfirm = true;        
    },

    onFilteredExpHeader(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.expHeader.total = filteredItems.length;
      this.expHeader.page = 1;
    },
    clearFilterExpHeader() {
      this.filterOnExpHeader = [];
      this.filterExpHeader = "";
    },
    onFilteredExpLine(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.expLines.total = filteredItems.length;
      this.expLines.page = 1;
    },
    clearFilterExpLine() {
      this.filterOnExpLine = [];
      this.filterExpLine = "";
    },
    rowClicked(record) {
      if (this.expHeader.selected && this.expHeader.selected._rowVariant) {
        delete this.expHeader.selected._rowVariant;
      }
            console.log('rowClicked record:',record)
      this.expHeader.selected = record;
            console.log('rowClicked this.expHeader.selected:',this.expHeader.selected)
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    openDetail: async function() {
      if (this.expHeader.items.length == 1)
        this.expHeader.selected = this.expHeader.items[0];
      if (this.expHeader.selected.trxhdrkey) {
        try {
          this.expHeader.selected.matauang = this.expHeader.selected.matauang || this.uanguser;
          this.isLoading = true;
          // const model=this.expLines.items[index];
          const listtrx = await expense.detail(this.expHeader.selected);
          this.expLines.items = listtrx;
          this.expLines.total = listtrx.length;
          this.calcDtlExp();
          this.isLoading = false;
          this.showList = false;
          this.showDetail = true;
        } catch (error) {
          console.log("save : ", error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);

          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Open/Show!");
      }
    },
    async openList() {
      const d = await expense.list(this.expHeader);
      this.expHeader.items = d || [];
      this.showList = true;
      this.showDetail = false;
    },
    onSelectLkuCoa(_selected) {
      this.expLinesObj.glAccount =
        _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
      this.expLinesObj.kodeacc = _selected.kodeacc;
      this.expLinesObj.namaacc = _selected.namaacc;
      this.lkuCoaShow = false;
    },
    addExpLines: function() {
      if (!this.expLinesObj.tanggal) {
        this.expLinesObj.tanggal = moment();
      }
      this.showDetailFrm = true;
    },
    editExpLines: function(obj) {
      this.expLines.selected = obj;
      for (var key in this.expLinesObj) {
        this.expLinesObj[key] = "";
      }
      for (var key in obj) {
        this.expLinesObj[key] = obj[key];
      }
      this.expLinesObj.dppnlain = this.expLinesObj.dppnlain || 100;
      this.expLinesObj.tanggal = moment(this.expLinesObj.trxdate);

      this.dimension.forEach(dim => {
        if (obj[dim.value]) {
          this.expLinesObj[dim.value] = obj[dim.value];
          this.expLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.expLinesObj[`${dim.value}Info`] =
            obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      this.showDetailFrm = true;
    },
    calcTaxes: function() {
      this.expLinesObj.dpp =
        (parseFloat(this.expLinesObj.nilai) *
          parseFloat(this.expLinesObj.dppnlain)) /
        100;
      if (this.expLinesObj.kenappn == 1) {
        this.expLinesObj.grossup = 0;
        this.expLinesObj.ppn = this.expLinesObj.ppn || 10;
      } else {
        // this.expLinesObj.dpp = 0;
        this.expLinesObj.ppn = 0;
      }
      if (this.expLinesObj.grossup == 1)
        this.expLinesObj.dpp =
          this.expLinesObj.dpp * (100 / (100 - this.expLinesObj.pph));

      this.expLinesObj.nilaippn =
        (this.expLinesObj.ppn / 100) * this.expLinesObj.dpp;
      if (this.calcPPh == 1)
        this.expLinesObj.nilaipph =
          (this.expLinesObj.dpp * parseFloat(this.expLinesObj.pph)) / 100;

      if (this.expLinesObj.grossup == 1) {
        this.expLinesObj.ukeluar =
          (this.expLinesObj.nilai || 0) +
          (this.expLinesObj.nilaipph || 0) +
          (this.expLinesObj.nilaippn || 0);
      } else {
        this.expLinesObj.ukeluar =
          (this.expLinesObj.nilai || 0) -
          (this.expLinesObj.nilaipph || 0) +
          (this.expLinesObj.nilaippn || 0);
      }
    },
    delLineConfirm(index) {
      this.expLines.index = index;
      // this.expHeader.selected=this.expHeader.items[index];
      this.showDelLineConfirm = true;
    },
    delExpLines: async function() {
      try {
        this.isLoading = true;
        const index = this.expLines.index;
        const model = this.expLines.items[index];
        await expense.removedetail(model);
        if (index > -1) {
          this.expLines.items.splice(index, 1);
        }
        this.expLines.total = this.expLines.items.length;
        this.calcDtlExp();
        this.isLoading = false;
      } catch (error) {
        console.log("save : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
        this.saveEnabled = true;
      }
    },
    saveExpLines: async function(evt) {
      evt.preventDefault();
      this.calcTaxes();
      if (this.invalidExpLines) {
        console.log("validation : ", this.$v.expLinesObj);
        console.log("model obj : ", this.expLinesObj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        if (!this.saveEnabled) {
          return;
        }
        this.saveEnabled = false;
        try {
          const model = {};
          this.expLinesObj.trxdate = moment(this.expLinesObj.tanggal).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.expLinesObj.trxhdrkey = this.expHeader.selected.trxhdrkey;
          for (var key in this.expLinesObj) {
            model[key] = this.expLinesObj[key];
          }
          const newTrx = await expense.savedetail(model);
          if (!model.trxkey) {
            model.trxkey = newTrx.trxkey;
            this.expLines.items.push(model);
            this.expLines.total = this.expLines.items.length;
          } else {
            for (var key in model) {
              this.expLines.selected[key] = model[key];
            }
          }
          this.expLines.items.sort(function(a, b) {
            var dateA = new Date(a.trxdate),
              dateB = new Date(b.trxdate);
            return dateA - dateB;
          });

          for (var key in this.expLinesObj) {
            this.expLinesObj[key] = "";
          }
          this.expLinesObj.trxkey = "";
          this.expLinesObj.matauang = this.expHeader.selected.matauang || this.$store.state.user.matauang;
          this.expLinesObj.nilai = 0;
          this.expLinesObj.uraian = "";
          this.expLinesObj.kodeacc = "";
          this.expLinesObj.ppn = 10;
          this.expLinesObj.dppnlain = 100;

          // this.dimension.forEach((dim) => {
          //     if (datadim[dim.value]) {
          //         this.expLines.selected[dim.value] = datadim[dim.value];
          //         this.expLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
          //     }
          // });
          this.calcDtlExp();
          expense.updateTotal({
            trxhdrkey: this.expHeader.selected.trxhdrkey,
            ttlKredit: this.ttlKredit
          });
          this.showDetailFrm = false;
          this.saveEnabled = true;
        } catch (error) {
          this.saveEnabled = true;
          console.log("error : ", error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);

          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    calcDtlExp: function() {
      let ttlKredit = 0;
      let saldo = this.expHeader.selected.umasuk;
      this.expLines.items.forEach(function(item) {
        if (item.uraian && item.nilai) {
          // ttlKredit += (item.nilai || 0);
          if (item.grossup == 1) {
            item.ukeluar =
              (item.nilai || 0) + (item.nilaipph || 0) + (item.nilaippn || 0);
          } else {
            item.ukeluar =
              (item.nilai || 0) - (item.nilaipph || 0) + (item.nilaippn || 0);
          }
          ttlKredit += item.ukeluar || 0;
          saldo -= item.ukeluar || 0;
          item.saldo = saldo;
        }
      });
      this.ttlKredit = ttlKredit;
    },
    add: function() {
      for (var key in this.frmhdr) {
        this.frmhdr[key] = "";
      }
      this.frmhdr.trxhdrkey = "";
      this.frmhdr.umasuk = 0;
      this.frmhdr.matauang = this.uanguser;
      this.showForm = true;
    },
    edit: function(obj) {
      this.expHeader.selected = obj;
      for (var key in this.frmhdr) {
        this.frmhdr[key] = "";
      }
      for (var key in obj) {
        this.frmhdr[key] = obj[key];
      }
      this.showForm = true;
    },
    delConfirm(index) {
      // this.expHeader.index = index;
      this.expHeader.selected=this.expHeader.items[index];
      this.showDelConfirm = true;
    },
    del: async function() {
      try {
        // let index = this.expHeader.index;
        this.isLoading = true;
        // const model = this.expHeader.items[index];
        await expense.remove(this.expHeader.selected.selected);
        this.openList();
        // if (index > -1) {
        //   this.expHeader.items.splice(index, 1);
        // }
        this.expHeader.total = this.expHeader.items.length;
        this.isLoading = false;
      } catch (error) {
        console.log("save : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
        this.saveEnabled = true;
      }
    },

    save: async function(evt) {
      evt.preventDefault();
      if (this.invalidModel) {
            const invalidobj={};
            for (var key in this.$v.frmhdr) {
            if (this.$v.frmhdr[key].$anyError) {
                if (this.$v.frmhdr[key].$anyError==true) invalidobj[key] = this.$v.frmhdr[key];
            }
            }        
            console.log('validation frmhdr: ', this.frmhdr);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        if (!this.saveEnabled) {
          return;
        }
        this.saveEnabled = false;
        try {
          const newTrx = await expense.save(this.frmhdr);
          // if (!this.frmhdr.trxhdrkey) {
          //   this.frmhdr.trxhdrkey = newTrx.trxhdrkey;
          //   this.expHeader.items.push(this.frmhdr);
          //   this.expHeader.total = this.expHeader.items.length;
          // } else {
          //   for (var key in this.frmhdr) {
          //     this.expHeader.selected[key] = this.frmhdr[key];
          //   }
          // }

          // this.dimension.forEach((dim) => {
          //     if (datadim[dim.value]) {
          //         this.expHeader.selected[dim.value] = datadim[dim.value];
          //         this.expHeader.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
          //     }
          // });
          this.openList();
          this.showForm = false;
          this.saveEnabled = true;
        } catch (error) {
          this.saveEnabled = true;
          console.log("error : ", error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);

          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },

    exportxls: async function() {
      if (!this.expHeader.selected) {
        console.log("model obj : ", this.expHeader.selected);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await expense.exportxls(this.expHeader.selected);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      // router.push("home");
      router.push({ name: "app.modules" });
    }
  }
};
</script>
